import React, { useState } from 'react';

export default function PasswordChange({ onBack }) {
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');

  async function submit(e) {
    e.preventDefault();
    setMsg('');
    if (newPassword !== confirm) {
      setMsg('New passwords do not match.');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('http://localhost:5000/auth/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      if (!res.ok) throw new Error(await res.text());
      setMsg('Password changed ✔');
      setCurrent(''); setNext(''); setConfirm('');
    } catch (e) {
      setMsg('Failed to change password.');
    }
  }

  return (
    <div className="login-form">
      <h1>Change password</h1>
      <form onSubmit={submit}>
        <label>Current password</label>
        <input type="password" value={currentPassword} onChange={e=>setCurrent(e.target.value)} />
        <label>New password</label>
        <input type="password" value={newPassword} onChange={e=>setNext(e.target.value)} />
        <label>Confirm new password</label>
        <input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} />
        <button type="submit">Save</button>
        <button type="button" style={{marginLeft:8}} onClick={onBack}>Back</button>
      </form>
      {msg && <p className="message">{msg}</p>}
    </div>
  );
}
